// extracted by mini-css-extract-plugin
module.exports = {"DraftEditor-root":"timed-text-editor_DraftEditor-root__2gPPc","editor":"timed-text-editor_editor__2F5j3"};